import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { container } from 'tsyringe';
import { ChatService } from '../../../services/chat-service';
import { useSharedState } from '../../../utils/helpers';
import { WebRTCsdkService } from '../../../services/webrtcsdk-service';
import { MeetingConnectionState } from '../../../models/meetingClass';

import "./HostChatTool.scss";
import DeleteHistoryDialog from './DeleteHistoryDialog';
import Badge from '../../badge/Badge';
import { Box } from '@mui/material';
import { StyledTab, StyledTabs, TabPanel } from '../../tabs/StyledTabs';
import { PrivateChatTool } from './PrivateChatTool';
import { ChatMessageInput } from './ChatMessageInput';

/* ChatMessage
body: "333"
event: {guid: '6f3a1468-52d6-4019-95d5-8b658bb09801'}
id: "06bf1e29df2147468fd505118bd3f973"
moderatorChat: true
moderatorPresenterChat: false
privateChat: false
sender: {guid: 'e2291758-cc4d-43fc-8718-33e86257cb2a', name: 'windows 2', role: 'moderator', userId: '4913571'}
tag: "moderator"
timestamp: 1639054361461
[[Prototype]]: Object
  */



export interface ChatMsgProp {
  msg: any;
}

export const ChatMsg = (props: ChatMsgProp) => {

  const { msg } = props;


  return (
    <>
      {msg.isSelf ?
        <div className='hostchattool-msg-container'>
          {/* {!msg.sameSender && */}
            <div className='hostchattool-msg-orig-self'>
              <div className='hostchattool-msg-name'>Me</div>
              <div className='hostchattool-msg-date'>{msg?.fromNow}</div>
            </div>
          {/* } */}
          <div className='hostchattool-msg-rectangle hostchattool-msg-rectangle-sentbyself'>{msg?.body}</div>
        </div>
        :
        <div className='hostchattool-msg-container'>
          {/* {!msg.sameSender && */}
            <div className='hostchattool-msg-orig'>
              <div className='hostchattool-msg-name'>{msg?.sender?.name}</div>
              <div className='hostchattool-msg-date'>{msg?.fromNow}</div>
            </div>
          {/* } */}
          <div className='hostchattool-msg-rectangle hostchattool-msg-rectangle-sentbyothers'>{msg?.body}</div>
        </div>
      }
    </>
  )

}

export const HostChatTool = () => {

  moment.updateLocale('en', {
    relativeTime: {
      future: "%s",
      past: "%s ago",
      s: 'a few seconds',
      ss: '%d seconds',
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%dh",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    }
  });

  const [chatService] = useState(container.resolve(ChatService));
  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));

  // const [showDeleteHistoryDialog, setShowDeleteHistoryDialog] = useState(false);

  const [backstageMsg, setBackstageMsg] = useState([]);
  const [moderatorMsg, setModeratorMsg] = useState([]);
  const [backstageMessages] = useSharedState(chatService.backstageChatMessages$);
  const [moderatorMessages] = useSharedState(chatService.moderatorChatMessages$);
  // const [clearHistory, setClearHistory] = useSharedState(chatService.clearHistory$);

  const [meetingState] = useSharedState(webRTCsdkService.meetingState$);
  const [isMeetingConnected, setMeetingConnected] = useState(true);  // DEMO connected by default


  const lastMsgBackstage = useRef(null);
  const lastMsgModerator = useRef(null);


  const savedTab = parseInt(localStorage.getItem('hostChatSelectedTab'));
  const [selectedTab, setSelectedTab] = useState(isNaN(savedTab) ? 0 : savedTab);

  const [unreadCounterBackstage] = useSharedState(chatService.unreadBackstageCounter$);
  const [unreadCounterModerator] = useSharedState(chatService.unreadModeratorCounter$);
  const [unreadCounterDirect] = useSharedState(chatService.unreadDirectCounter$);


  const scrollToRef = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  // uncomment to refresh fromNow time every 1min
  // useEffect(() => {
  //   let refreshInterval = setInterval(() => {
  //     if (selectedTab === 0) {
  //       getBackstageHistory();
  //     } else if (selectedTab === 1) {
  //       getModeratorHistory();
  //     } else {
  //       // personal chat
  //     }
  //   }, 60000);  // 1min refresh
  //   return () => {
  //     clearInterval(refreshInterval);
  //   }
  // }, [])


  const getBackstageHistory = useCallback(async () => {

    // get all backstage messages history
    const backstageChatHistory = chatService.backstageChatMessages$.getValue();

    // reset unread counter if selectedTab is backstage
    if (selectedTab === 0) {
      console.log('reset backstage counters');
      chatService.resetUnreadBackstageChat();
    }

    if (backstageChatHistory && backstageChatHistory.length > 0) {
      const msg = [];
      let prev = null;
      backstageChatHistory.map(m => {
        const date = moment.unix(m.timestamp / 1000).format('LT');
        const fromNow = moment.unix(m.timestamp / 1000).fromNow();
        const sameSender = (m.sender?.name === prev);
        prev = m.sender?.name;
        msg.push({ ...m, date, fromNow, sameSender });
      });
      console.log('HOSTCHAT backstage get all history', msg.length)
      setTimeout(() => {
        // give time for lastMsg elem to be diplayed at right topOffet
        scrollToRef(lastMsgBackstage);
      }, 20);
      setBackstageMsg(msg);
    }
  }, [chatService, selectedTab]);

  const getModeratorHistory = useCallback(async () => {

    // get all public messages history
    const moderatorChatHistory = chatService.moderatorChatMessages$.getValue();

    // reset unread counter if selectedTab is moderator
    if (selectedTab === 1) {
      console.log('reset moderator counters');
      chatService.resetUnreadModeratorChat();
    }

    if (moderatorChatHistory && moderatorChatHistory.length > 0) {
      const msg = [];
      let prev = null;
      moderatorChatHistory.map(m => {
        const date = moment.unix(m.timestamp / 1000).format('LT');
        const fromNow = moment.unix(m.timestamp / 1000).fromNow();
        const sameSender = (m.sender?.name === prev);
        prev = m.sender?.name;
        msg.push({ ...m, date, fromNow, sameSender });
      });
      console.log('HOSTCHAT moderator get all history', msg.length)
      setTimeout(() => {
        // give time for lastMsg elem to be displayed at right topOffset
        scrollToRef(lastMsgModerator);
      }, 20);
      setModeratorMsg(msg);
    }
  }, [chatService, selectedTab]);

  useEffect(() => {
    // console.log('backstage', selectedTab);
    getBackstageHistory()
  }, [selectedTab, backstageMessages]);

  useEffect(() => {
    // console.log('moderator', selectedTab);
    getModeratorHistory()
  }, [selectedTab, moderatorMessages]);


  useEffect(() => {
    console.log('unread backstage counters', unreadCounterBackstage);
  }, [unreadCounterBackstage])

  useEffect(() => {
    console.log('unread moderator counters', unreadCounterModerator);
  }, [unreadCounterModerator])

  useEffect(() => {
    console.log('HOSTCHAT', meetingState);
    if (meetingState) {
      const isConnected = meetingState.connexionState === MeetingConnectionState.CONNECTED;
      if (isConnected && !isMeetingConnected) {
        // reset unread counter
        if (selectedTab === 0) {
          console.log('reset backstage counters');
          chatService.resetUnreadBackstageChat();
        } else if (selectedTab === 1) {
          console.log('reset moderator counters');
          chatService.resetUnreadModeratorChat();
        }

        // wasn't connected => get history
        setTimeout(() => {
          getBackstageHistory();
          getModeratorHistory();
        }, 1000);
      }
      setMeetingConnected(true);
    }
  }, [meetingState])

  const onSendMessage = (msg: string, tab: 'backstage' | 'moderator') => {
    chatService.sendChatMessage(msg, tab);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    localStorage.setItem('hostChatSelectedTab', newValue.toString());
    setSelectedTab(newValue);
    // if (newValue === 0) {
    //   console.log('reset backstage counters');
    //   chatService.resetUnreadBackstageChat();
    // } else if (newValue === 1) {
    //   console.log('reset moderator counters');
    //   chatService.resetUnreadModeratorChat();
    // }
  }


  // const actionDeleteHistory = (res) => {
  //   if (res === 'yes') {
  //     // chatService.clearPublicChat();
  //   }
  //   setShowDeleteHistoryDialog(false);
  // }
  // console.log('HOSTCHAT', backstageMsg);


  return (
    <>
      {isMeetingConnected ?

        <>
          <Box sx={{ bgcolor: '#ffffff', width: '100%', marginTop: '5px' }}>
            <StyledTabs
              value={selectedTab}
              onChange={handleTabChange}
              aria-label="styled tabs example"
            >
              <StyledTab label={<><div className="label">Backstage</div><Badge counter={unreadCounterBackstage} top={24} left={95} background={" linear-gradient(315deg, #c94bf9, #55adde)"}></Badge></>} />
              <StyledTab label={<><div className="label">Moderator Group</div><Badge counter={unreadCounterModerator} top={24} left={144} background={" linear-gradient(315deg, #c94bf9, #55adde)"}></Badge></>} />
              <StyledTab label={<><div className="label">Direct Message</div><Badge counter={unreadCounterDirect} top={24} left={131} background={" linear-gradient(315deg, #c94bf9, #55adde)"}></Badge></>} />
            </StyledTabs>
          </Box>
          <TabPanel value={selectedTab} index={0}>
            <>
              <div className="hostchattool-wrapper">
                {backstageMsg.length > 0 ?
                  <ul>
                    {
                      backstageMsg.map(m =>
                        <li key={m.id}>
                          <ChatMsg msg={m}></ChatMsg>
                        </li>
                      )
                    }
                    <li ref={lastMsgBackstage} id="dummy for scrollIntoView" className="hostchattool-last-message"></li>
                  </ul>
                  :
                  <div className='hostchattool-welcome'>
                    <div className='hostchattool-welcome-img hostchattool-welcome-img-backstage'></div>
                    <div className='hostchattool-welcome-title'>Welcome to Backstage Chat!</div>
                    <div className='hostchattool-welcome-tips'>Use this chat to talk privately with your fellow presenters before or during your event.</div>
                  </div>
                }
              </div>

              <ChatMessageInput onSendMessage={(msg) => onSendMessage(msg, 'backstage')} clearInput={selectedTab === 0} placeHolder={'Chat privately with your co-hosts…'} />
            </>

          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <>
              <div className="hostchattool-wrapper">
                {moderatorMsg.length > 0 ?
                  <ul>
                    {
                      moderatorMsg.map(m =>
                        <li key={m.id}>
                          <ChatMsg msg={m}></ChatMsg>
                        </li>
                      )
                    }
                    <li ref={lastMsgModerator} id="dummy for scrollIntoView" className="hostchattool-last-message"></li>
                  </ul>
                  :
                  <div className='hostchattool-welcome'>
                    <div className='hostchattool-welcome-img hostchattool-welcome-img-moderator'></div>
                    <div className='hostchattool-welcome-title'>Welcome to Moderator Chat!</div>
                    <div className='hostchattool-welcome-tips'>Use this chat to talk privately to the moderators.</div>
                  </div>
                }
              </div>
              <ChatMessageInput onSendMessage={(msg) => onSendMessage(msg, 'moderator')} clearInput={selectedTab === 0}  placeHolder={'Chat privately with your co-hosts…'} />
            </>

          </TabPanel>
          <TabPanel value={selectedTab} index={2}>
            <>
              <PrivateChatTool></PrivateChatTool>
            </>
          </TabPanel>
        </>
        :

        <>
          Waiting for the Meeting to be connected.
        </>
      }
      {/* <DeleteHistoryDialog open={showDeleteHistoryDialog} onClose={(e) => actionDeleteHistory(e)}></DeleteHistoryDialog> */}
    </>
  )
}